import styles from "./Philosophie.module.css";
import philosophie from './assets/11062b_95c05085f74d4a44842ef9b5285e5c12~mv2.avif';
import React from "react";

const Philosophie = () => {

  return(
      <>

          <div
              className={styles.hero}
              style={{ backgroundImage: `url(${philosophie})` }}
          />
        <main className="wrapper">
             <section className="wrapperContent">
              <div className={styles.text}>
                  <h1>DIE PHILOSOPHIE</h1>
                  <h2>Unsere Vision der Vielfalt und Demokratie</h2>
                  <p>
                      Die IKS-Interkulturelle Schule Rhein Main (IKS-RM) hat eine klare Vision: Vielfalt ist unsere Stärke.
                      Wir legen hohe Erwartungen an uns und alle Mitglieder unserer Schule und fördern eine demokratische
                      Kultur, in der alle freundlich und wertschätzend miteinander umgehen. Wir leben demokratische Werte
                      und eröffnen Freiräume der Mitbestimmung. Konstruktiver Umgang mit Konflikten und Prävention sind uns
                      ebenso wichtig wie höfliche Umgangsformen, die Ablehnung von Gewalt und Respekt für die Meinung
                      anderer. Wir hören einander zu und reden miteinander statt übereinander.
                  </p>
              </div>
          <div className={styles.text}>
              <h2>Individuelle Persönlichkeitsentwicklung und differenzierter Unterricht</h2>
              <p>
                  Unser Ziel ist es, die individuelle Persönlichkeitsentwicklung jeder Schülerin und jedes Schülers in
                  der Gemeinschaft der Lerngruppe zu fördern und die Vielfalt als Ressource zu nutzen. Wir stellen die
                  Stärken unserer Schülerinnen und Schüler in den Vordergrund und arbeiten binnendifferenziert.
                  Kooperative Lernformen werden durch intensives Methodentraining geübt und Unterrichtsinhalte
                  didaktisch und methodisch gemeinsam vorbereitet und reflektiert. Die Evaluation unseres Unterrichts
                  erfolgt im Team.
              </p>
              <p>
                  Wir nutzen alle Ressourcen zur Gestaltung eines gemeinsamen und individualisierten Unterrichts. Dazu
                  gehören das Fördern des selbstständigen Lernens, regelmäßige Besuche von außerschulischen Lernorten,
                  die Möglichkeit zum jahrgangsübergreifenden Projektunterricht sowie das Zurückgreifen auf das Wissen
                  von Menschen aus dem Umfeld. Wir fördern Patenschaften und Helfersysteme.
              </p>
          </div>
          <div className={styles.text}>
              <h2>Bildungskonzept und Mehrsprachigkeit</h2>
              <p>
                  Unser Leitbild basiert auf einem hervorragenden Bildungskonzept, das theoretisches Lernen mit
                  praktischem Tun, Handeln und Wissen vereint. Die IKS-RM legt besonderen Wert auf Mehrsprachigkeit und
                  innovative Lehr- und Lernmethoden. Die Bildung und Persönlichkeitsentwicklung unserer Schülerinnen und
                  Schüler stehen im Vordergrund, damit sie bestens für Beruf oder Studium gerüstet sind. Wir sind stolz
                  darauf, uns als interkulturelle Schule zu bezeichnen und voneinander zu lernen, unser kulturelles
                  Wissen zu erweitern und ein gemeinsames Miteinander zu pflegen.
              </p>
          </div>

          <div>
              <div >
                  <div className={styles.list}>
                      <h2>Unsere demokratische Kultur</h2>
                      <ul>
                          <li>Schule als Lebensraum</li>
                          <li>Freundlicher und wertschätzender Umgang miteinander</li>
                          <li>Demokratische Werte und Mitbestimmung</li>
                          <li>Konfliktlösung und Präventionskonzept</li>
                          <li>Keine Gewalt, höfliche Umgangsformen</li>
                          <li>Respekt und Meinungsfreiheit</li>
                          <li>Zuhören und miteinander Reden</li>
                      </ul>
                  </div>

                  <div className={styles.list}>
                      <h2>Unsere Vielfalt als Stärke</h2>
                      <ul>
                          <li>Individuelles Lernen und Förderung der Stärken</li>
                          <li>Binnendifferenzierung und kooperative Lernformen</li>
                          <li>Gemeinsame Vorbereitung und Evaluation des Unterrichts</li>
                          <li>Außerschulische Lernorte und Projektunterricht</li>
                          <li>Nutzung von Ressourcen aus dem Umfeld</li>
                          <li>Patenschaften und Helfersysteme</li>
                      </ul>
                  </div>

                  <div className={styles.list}>
                      <h2>Unser interkulturelles Leitbild</h2>
                      <ul>
                          <li>Verbindung von Schule und Arbeit</li>
                          <li>Interkulturelles Lernen und Wissen</li>
                          <li>Fremdsprachen als Schlüssel zur Welt</li>
                          <li>Innovative Lehr- und Lernmethoden</li>
                          <li>Persönlichkeitsentwicklung und bestmögliche Schulbildung</li>
                      </ul>
                  </div>
              </div>

          </div>
          </section>
      </main>
      </>
  );
};

export default Philosophie;